const SET_ITEMS = (state, obj) => {
  state.items = obj.data;
  state.totalHours = obj.total_hours;
  state.perPage = obj.per_page;
  state.page = obj.page;
  state.total = obj.total;
};

const ADD_ITEM = (state, obj) => {
  state.items = [obj, ...state.items];
};

const EDIT_ITEM = (state, obj) => {
  const items = [...state.items];
  const index = items.findIndex(p => p.pk == obj.pk);
  items[index] = { ...obj };
  state.items = items;
};

const DELETE_ITEM = (state, obj) => {
  state.items = state.items.filter(p => p.pk !== obj.pk);
};

const TOGGLE_CONFERRED = (state, obj) => {
  const items = [...state.items];
  const index = items.findIndex(p => p.pk == obj);
  items[index] = {
    ...items[index],
    conferred: !items[index].conferred,
  };
  state.items = items;
};

export default {
  SET_ITEMS,
  ADD_ITEM,
  EDIT_ITEM,
  DELETE_ITEM,
  TOGGLE_CONFERRED
};
